import type { Locale } from "@porsche-customer/slfinrtl-context-types"
import type { ApiRoute, NoBody, NoQueryParams } from "../../api"
import type { DocumentResponse } from "../../common"

export interface GetTyreLabelsPathParams {
	inventoryId: string
	languageTag: Locale
}

export const generateTyreLabelsRoute: ApiRoute<GetTyreLabelsPathParams, NoQueryParams, NoBody, DocumentResponse> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/tyre-labels/${params.languageTag}`,
	method: "get",
	path: "/vehicles/:inventoryId/tyre-labels/:languageTag",
}
